var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVnFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2560 1707",
    style: {
      enableBackground: "new 0 0 2560 1707"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DA251D;}\r\n\t.st1{fill:#FFFF00;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1707.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,8535V0h12800h12800v8535v8535H12800H0V8535z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17660,10106c-8-8-683-499-1500-1091s-1486-1082-1488-1089c-1-6,254-801,568-1765c314-965,569-1756,567-1757 c-2-2-677,484-1499,1081c-823,597-1501,1085-1508,1085c-6,0-685-488-1507-1085c-823-597-1498-1083-1500-1082c-2,2,253,793,567,1758 c314,964,569,1759,568,1766c-2,6-671,496-1488,1088c-817,592-1492,1083-1500,1091c-12,12,242,14,1847,14h1861l84,258 c46,141,304,935,573,1764c270,829,492,1508,495,1508c3,0,225-679,495-1508c269-829,527-1623,573-1764l84-258h1861 C17425,10120,17672,10118,17660,10106z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVnFlag);
export default __webpack_public_path__ + "static/media/vn_flag.06c7300d.svg";
export { ForwardRef as ReactComponent };